import React from 'react';
import { BsShareFill } from 'react-icons/bs';
import { getCardAction } from '../utils';
import * as nativeEvents from '../../../Helper/native';
import { ASSET_URLS, CAMPAIGN_CONFIG } from '../constants';
import MnthEndFAQ from '../../MnthEndFAQ';
import MthEndTAndC from '../../MthEndTAndC';

const initiaData = require('../../urlEncodeTest.json');

const HeaderBanner = ({ cardType, cardPaymentStatus, onShare, loading }) => {
  const handleCardAction = () => {
    if (loading) return;
    const action = getCardAction(cardType, cardPaymentStatus);
    nativeEvents[action]();
  };

  return (
    <div className="headerImgContainerOneMonth">
      {/* <div className="headerCta">
        <button
          className="shareCta"
          onClick={() => onShare(initiaData.floatingShareMsg.msg)}
        >
          <BsShareFill size={22} color="#FFFFFF" />
        </button>
      </div> */}
      {/* <div className="offerTillTextContainer">
        <span className="offerTillText">
            OFFER TILL 31st JAN
        </span>
      </div> */}
      <div style={{ position: 'relative', marginTop: '20px', textAlign: 'center' }}>
        <div className="head-title-month">{CAMPAIGN_CONFIG.TITLE}</div>
        <div className="cardImgContainer">
        <div className="head-subtitle-month">
          Up to <span className="highlightText">5% back</span> in Bitcoin and Gold on spends.
          Redeem up to <span className="highlightText">90%</span> of your rewards on vouchers.
        </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '8px',
          marginBottom: '8px',
          width: '100%',
        }}
      >
        <img
          src={ASSET_URLS.JULY_HERO}
          style={{ width: '80%', height: 'auto' }}
          alt="Up to 5% rewards, valid till July 31st"
        />
      </div>
        <button
          className="addMoneyButton"
          onClick={handleCardAction}
          disabled={loading}
        >
          {loading ? (
            <span
              style={{
                display: 'block',
                width: '22px',
                height: '22px',
                margin: '0 auto',
                border: '3px solid rgba(0, 0, 0, 0.2)',
                borderTopColor: '#000000',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
              }}
            />
          ) : (
            'SPEND AND EARN'
          )}
        </button>
        <button
          className="redeemVoucherButton"
          onClick={() => nativeEvents.offersBrands()}
          disabled={loading}
        >
          REDEEM VOUCHERS
        </button>

      <div className="footerContainer" style={{ marginTop: '0px' }}>
        <div style={{ padding: '0px 0px 50px 0px' }}>
          <div style={{ marginTop: '25px' }}>
            <MnthEndFAQ />
          </div>
          <MthEndTAndC />
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
